const layout = () => import(/* webpackChunkName: "layout" */ '@/components/layout');

export default [
  {
    path: '',
    component: layout,
    children: [
      {
        name: 'refundList',
        component: () => import(/* webpackChunkName: "b2b_refund_list" */ '@/pages/refund/list'),
        meta: {
          title: '退款/售后管理'
        },
        path: '/refundList'
      },
      {
        name: 'refundDetail',
        component: () => import(/* webpackChunkName: "b2b_refund_list" */ '@/pages/refund/detail'),
        meta: {
          title: '退款/售后详情'
        },
        path: '/refundDetail'
      }
    ]
  }
];
